import React, { useState,useEffect } from 'react';
// import './dropdown.scss';
import { Select, MenuItem } from "@mui/material/";

function Select2(props){
    const [selectedOption2, setSelectedOption2] = useState(" ");
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setSelectedOption2(props.defaultValue);
    }, [props.defaultValue]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const handleChange = (e) => {
        setSelectedOption2(e.target.value)
        props.setSelectedSelect2Value(e.target.value)
    }
    return (
        <>
            <div className="dropdown-schedule">
                <Select
                    sx={{ width: '10rem',height:'2.2rem'}}
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={selectedOption2}
                    onChange={handleChange}
                    placeholder="No Animation"
                    displayEmpty
                >
                    <MenuItem value="">
                        <em>No Animation</em>
                    </MenuItem>
                    <MenuItem value="fadein">Fade in</MenuItem>
                    <MenuItem value="fadeout">Fade out</MenuItem>
                </Select>
            </div>
        </>
    );
}
export default Select2